<template>
  <div class="sso_options_container">
    <div class="solid-divider" v-if="listOfPlatform.length > 0">
      <div
        style="text-align: center"
        class="text-primary text-body link-opacity-50-hover"
      >
        {{ $t("login.other_option") }}
      </div>
    </div>

    <div class="" v-for="platform in listOfPlatform" :key="platform + 1">
      <b-button
        variant="white"
        class="sso_btn sso_btn_google"
        @click="getPlatformUrl(platform)"
      >
        <img
          class="icon"
          :src="require(`@/assets/images/pages/login/${platform}-logo.png`)"
          :alt="`${platform} icon`"
        />
        <span class="text"
          >{{ $t("login.sign_in_with") }} <span>{{ platform }}</span></span
        >
      </b-button>
    </div>
  </div>
</template>

<script>
import useSingleSignOn from "@/composables/singleSignOn";
import router from "@/router";

export default {
  setup() {
    const { getPlatformUrl } = useSingleSignOn();

    let listOfPlatform = [];

    const hostname = window.location.hostname;

    const hasBanamex = /(^|[.-])banamex([.-]|$)/.test(hostname);

    if (hasBanamex) {
      listOfPlatform = ["saml2"];
    } else {
      listOfPlatform = ["google"];
    }

    return {
      getPlatformUrl,
      listOfPlatform,
    };
  },
};
</script>

<style lang="scss"></style>
